<div class="graph-section">

    <div class="graph-top-section">
        <div class="graph-top-section-text-section">
            <h3 class="graph-title">{{title}}</h3>
            <p class="graph-explanation-text">{{briefDescription}}</p>
            <div class="tooltip-frame">
                <ng-content select="[keyupdates]"></ng-content> 
            </div>
        </div>
        <div class="button-container" *ngIf="!!showExportButton">
            <button type="button" 
                class="nsw-button nsw-button--dark-outline-solid"            
                (click)="onExportDataClicked()">Export this data
            </button>
        </div>        
    </div>

    <span class="brief-desc">{{chartTitle}}</span>

    <div class="chart-frame">
        <ng-content select="[chart]"></ng-content>
    </div> 

    <div class="accordion-section">
        <app-accordion title="Table">
            <ng-content select="[table]"></ng-content>
        </app-accordion>
    </div>
</div>                               


